export default {
    en: 'English',
    pl: 'Polski',
};
